import { render, staticRenderFns } from "./performanceChart.vue?vue&type=template&id=35858e68&scoped=true&"
import script from "./performanceChart.vue?vue&type=script&lang=js&"
export * from "./performanceChart.vue?vue&type=script&lang=js&"
import style0 from "./performanceChart.vue?vue&type=style&index=0&id=35858e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35858e68",
  null
  
)

export default component.exports